/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_History_TitleInputs */

const cs_ebr_history_title = /** @type {(inputs: Ebr_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historie importů`)
};

const en_ebr_history_title = /** @type {(inputs: Ebr_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import history`)
};

/**
* | output |
* | --- |
* | "Import history" |
*
* @param {Ebr_History_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_history_title = /** @type {((inputs?: Ebr_History_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_History_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_history_title(inputs)
	return cs_ebr_history_title(inputs)
});